import Vue from "vue";
import Component from "vue-class-component";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "Feedback" })
export default class Feedback extends Vue {
    private localizer: any = Localizer;
    private isRating: boolean = false;
    private ratingChoise: string = null;

    private setFeedback(choise: string) {
        if (this.isRating) {
            return;
        }

        if (choise == 'yes') {
            GTagHelper.sendEvent("click", { feedback: "like" });
        }

        if (choise == 'no') {
            GTagHelper.sendEvent("click", { feedback: "dislike" });
        }

        this.ratingChoise = choise;
        this.isRating = true;
    }
}